'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/progress/style/index.js
// module id = 1055
// module chunks = 1